var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemdemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsKrita: "http://krita.org/namespaces/svg/krita",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    width: "545.04pt",
    height: "252.72pt",
    viewBox: "0 0 545.04 252.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "shape0",
    transform: "matrix(0.719999996255512 0 0 0.719999996255512 -55.0799868831374 547.559992909498)",
    fill: "#ffffff",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    width: 1000,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group0",
    transform: "matrix(0.503999997378858 0 0 0.503999997378858 20.5199913742504 11.8665212805455)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(2.52 0 0 2.52 1.64480000000002 0.310098109202443)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group1",
    transform: "matrix(0.999999996556935 0 0 0.999999996556935 6.17406465508452e-06 2.8421709430404e-14)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group2",
    transform: "matrix(0.995024902878658 0 0 0.995024902878658 3.5527136788005e-15 5.94624793848197e-10)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r$-0",
    transform: "translate(3.5527136788005e-15, 96.5172411670466)",
    fill: "#c56e33",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    width: 397.4976,
    height: 5.37924325818883,
    rx: 3.97497589111328,
    ry: 2.68962162909441
  })), /*#__PURE__*/React.createElement("g", {
    id: "group3",
    transform: "matrix(0.995024902878658 0 0 0.995024902878658 0.983880623966392 115.401269887397)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform",
    transform: "matrix(0.999999990320315 0 0 0.999999990320315 7.40741851146254e-06 0)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group4",
    transform: "matrix(0.999999990320315 0 0 0.999999990320315 7.40741849369897e-06 0)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group5",
    transform: "matrix(0.999999990320315 0 0 0.999999990320315 7.40741849369897e-06 0)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "text-0",
    transform: "matrix(1.71406287614822 0 0 1.71406287614822 0.00856131183201114 1.30772622242148e-06)",
    fill: "#551e19",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M12.25 33.95L0 33.95L0 32.9L1 32.55C2.06667 32.2167 2.6 31.3833 2.6 30.05L2.6 30.05C2.63333 28.15 2.65 26.2067 2.65 24.22C2.65 22.24 2.65 20.2167 2.65 18.15L2.65 18.15L2.65 16.4C2.65 14.4667 2.65 12.5333 2.65 10.6C2.65 8.66667 2.63333 6.73333 2.6 4.8L2.6 4.8C2.6 3.43333 2.08333 2.58333 1.05 2.25L1.05 2.25L0 1.95L0 0.9L13.15 0.9C16.65 0.9 19.6667 1.55 22.2 2.85C24.7333 4.15 26.6833 6.02333 28.05 8.47C29.4167 10.9233 30.1 13.8833 30.1 17.35L30.1 17.35C30.1 20.8833 29.36 23.8833 27.88 26.35C26.3933 28.8167 24.31 30.7 21.63 32C18.9433 33.3 15.8167 33.95 12.25 33.95ZM9.85 32.5L9.85 32.5L12.4 32.5C14.7667 32.5 16.6933 32.0333 18.18 31.1C19.66 30.1667 20.75 28.59 21.45 26.37C22.15 24.1567 22.5 21.1667 22.5 17.4L22.5 17.4C22.5 13.6333 22.15 10.65 21.45 8.45C20.75 6.25 19.6767 4.68333 18.23 3.75C16.7767 2.81667 14.9 2.35 12.6 2.35L12.6 2.35L9.85 2.35C9.81667 4.65 9.8 6.97333 9.8 9.32C9.8 11.6733 9.8 14.0333 9.8 16.4L9.8 16.4L9.8 18.1C9.8 20.6 9.8 23.04 9.8 25.42C9.8 27.8067 9.81667 30.1667 9.85 32.5ZM57.1 33.95L32.3 33.95L32.3 32.9L33.3 32.55C33.9 32.3833 34.3167 32.0933 34.55 31.68C34.7833 31.26 34.9167 30.6833 34.95 29.95L34.95 29.95L34.95 4.8C34.9167 4.1 34.8 3.55667 34.6 3.17C34.4 2.79 33.9833 2.5 33.35 2.3L33.35 2.3L32.3 1.95L32.3 0.9L56.1 0.9L56.45 8.9L55.05 8.9L53.05 4.4C52.7833 3.76667 52.4833 3.27333 52.15 2.92C51.8167 2.57333 51.3167 2.4 50.65 2.4L50.65 2.4L42.15 2.4C42.1167 4.46667 42.1 6.59 42.1 8.77C42.1 10.9567 42.1 13.4167 42.1 16.15L42.1 16.15L47.05 16.15C47.7167 16.15 48.2233 15.9767 48.57 15.63C48.9233 15.2767 49.25 14.8 49.55 14.2L49.55 14.2L50.4 12.3L51.5 12.3L51.5 21.55L50.4 21.55L49.5 19.65C49.2333 19.05 48.9333 18.5667 48.6 18.2C48.2667 17.8333 47.7667 17.65 47.1 17.65L47.1 17.65L42.1 17.65C42.1 20.05 42.1 22.1167 42.1 23.85C42.1 25.5833 42.1067 27.1233 42.12 28.47C42.14 29.8233 42.15 31.15 42.15 32.45L42.15 32.45L51.75 32.45C52.4167 32.45 52.9333 32.2767 53.3 31.93C53.6667 31.5767 53.9667 31.0833 54.2 30.45L54.2 30.45L56.05 25.95L57.45 25.95ZM66.9 33.95L59.9 33.95L59.9 32.85L60.9 32.55C61.5333 32.35 61.9667 32.0233 62.2 31.57C62.4333 31.1233 62.55 30.5333 62.55 29.8L62.55 29.8L62.55 5.05C62.55 4.38333 62.4667 3.84 62.3 3.42C62.1333 3.00667 61.7167 2.68333 61.05 2.45L61.05 2.45L59.9 2L59.9 0.9L69.45 0.9L78.85 25.35L87.7 0.9L97.45 0.9L97.45 2L96.65 2.25C96.0167 2.45 95.5833 2.75667 95.35 3.17C95.1167 3.59 95 4.13333 95 4.8L95 4.8C94.9667 6.73333 94.95 8.65667 94.95 10.57C94.95 12.49 94.95 14.4333 94.95 16.4L94.95 16.4L94.95 18.45C94.95 20.3833 94.95 22.3167 94.95 24.25C94.95 26.1833 94.9667 28.1 95 30L95 30C95 30.7 95.0833 31.2333 95.25 31.6C95.4167 31.9667 95.8167 32.2667 96.45 32.5L96.45 32.5L97.45 32.85L97.45 33.95L85.3 33.95L85.3 32.85L86.4 32.5C87.0333 32.2667 87.4233 31.9567 87.57 31.57C87.7233 31.19 87.8 30.6667 87.8 30L87.8 30L87.8 19.15L87.9 5.75L77.7 33.95L74.9 33.95L64.15 6.05L64.35 17.45L64.35 29.85C64.35 30.5833 64.45 31.1667 64.65 31.6C64.85 32.0333 65.2667 32.3333 65.9 32.5L65.9 32.5L66.9 32.85ZM111.99 33.95L99.74 33.95L99.74 32.9L100.74 32.55C101.807 32.2167 102.34 31.3833 102.34 30.05L102.34 30.05C102.373 28.15 102.39 26.2067 102.39 24.22C102.39 22.24 102.39 20.2167 102.39 18.15L102.39 18.15L102.39 16.4C102.39 14.4667 102.39 12.5333 102.39 10.6C102.39 8.66667 102.373 6.73333 102.34 4.8L102.34 4.8C102.34 3.43333 101.823 2.58333 100.79 2.25L100.79 2.25L99.74 1.95L99.74 0.9L112.89 0.9C116.39 0.9 119.407 1.55 121.94 2.85C124.473 4.15 126.423 6.02333 127.79 8.47C129.157 10.9233 129.84 13.8833 129.84 17.35L129.84 17.35C129.84 20.8833 129.1 23.8833 127.62 26.35C126.133 28.8167 124.05 30.7 121.37 32C118.683 33.3 115.557 33.95 111.99 33.95ZM109.59 32.5L109.59 32.5L112.14 32.5C114.507 32.5 116.433 32.0333 117.92 31.1C119.4 30.1667 120.49 28.59 121.19 26.37C121.89 24.1567 122.24 21.1667 122.24 17.4L122.24 17.4C122.24 13.6333 121.89 10.65 121.19 8.45C120.49 6.25 119.417 4.68333 117.97 3.75C116.517 2.81667 114.64 2.35 112.34 2.35L112.34 2.35L109.59 2.35C109.557 4.65 109.54 6.97333 109.54 9.32C109.54 11.6733 109.54 14.0333 109.54 16.4L109.54 16.4L109.54 18.1C109.54 20.6 109.54 23.04 109.54 25.42C109.54 27.8067 109.557 30.1667 109.59 32.5ZM156.84 33.95L132.04 33.95L132.04 32.9L133.04 32.55C133.64 32.3833 134.057 32.0933 134.29 31.68C134.523 31.26 134.657 30.6833 134.69 29.95L134.69 29.95L134.69 4.8C134.657 4.1 134.54 3.55667 134.34 3.17C134.14 2.79 133.723 2.5 133.09 2.3L133.09 2.3L132.04 1.95L132.04 0.9L155.84 0.9L156.19 8.9L154.79 8.9L152.79 4.4C152.523 3.76667 152.223 3.27333 151.89 2.92C151.557 2.57333 151.057 2.4 150.39 2.4L150.39 2.4L141.89 2.4C141.857 4.46667 141.84 6.59 141.84 8.77C141.84 10.9567 141.84 13.4167 141.84 16.15L141.84 16.15L146.79 16.15C147.457 16.15 147.967 15.9767 148.32 15.63C148.667 15.2767 148.99 14.8 149.29 14.2L149.29 14.2L150.14 12.3L151.24 12.3L151.24 21.55L150.14 21.55L149.24 19.65C148.973 19.05 148.673 18.5667 148.34 18.2C148.007 17.8333 147.507 17.65 146.84 17.65L146.84 17.65L141.84 17.65C141.84 20.05 141.84 22.1167 141.84 23.85C141.84 25.5833 141.85 27.1233 141.87 28.47C141.883 29.8233 141.89 31.15 141.89 32.45L141.89 32.45L151.49 32.45C152.157 32.45 152.673 32.2767 153.04 31.93C153.407 31.5767 153.707 31.0833 153.94 30.45L153.94 30.45L155.79 25.95L157.19 25.95ZM166.64 33.95L159.64 33.95L159.64 32.85L160.64 32.55C161.273 32.35 161.707 32.0233 161.94 31.57C162.173 31.1233 162.29 30.5333 162.29 29.8L162.29 29.8L162.29 5.05C162.29 4.38333 162.207 3.84 162.04 3.42C161.873 3.00667 161.457 2.68333 160.79 2.45L160.79 2.45L159.64 2L159.64 0.9L169.19 0.9L178.59 25.35L187.44 0.9L197.19 0.9L197.19 2L196.39 2.25C195.757 2.45 195.323 2.75667 195.09 3.17C194.857 3.59 194.74 4.13333 194.74 4.8L194.74 4.8C194.707 6.73333 194.69 8.65667 194.69 10.57C194.69 12.49 194.69 14.4333 194.69 16.4L194.69 16.4L194.69 18.45C194.69 20.3833 194.69 22.3167 194.69 24.25C194.69 26.1833 194.707 28.1 194.74 30L194.74 30C194.74 30.7 194.823 31.2333 194.99 31.6C195.157 31.9667 195.557 32.2667 196.19 32.5L196.19 32.5L197.19 32.85L197.19 33.95L185.04 33.95L185.04 32.85L186.14 32.5C186.773 32.2667 187.163 31.9567 187.31 31.57C187.463 31.19 187.54 30.6667 187.54 30L187.54 30L187.54 19.15L187.64 5.75L177.44 33.95L174.64 33.95L163.89 6.05L164.09 17.45L164.09 29.85C164.09 30.5833 164.19 31.1667 164.39 31.6C164.59 32.0333 165.007 32.3333 165.64 32.5L165.64 32.5L166.64 32.85ZM215.09 34.8L215.09 34.8C213.057 34.8 211.107 34.4333 209.24 33.7C207.373 32.9667 205.697 31.8733 204.21 30.42C202.73 28.9733 201.557 27.1667 200.69 25C199.823 22.8333 199.39 20.3 199.39 17.4L199.39 17.4C199.39 14.5667 199.823 12.0667 200.69 9.9C201.557 7.73333 202.73 5.91667 204.21 4.45C205.697 2.98333 207.38 1.87333 209.26 1.12C211.147 0.373333 213.09 0 215.09 0L215.09 0C217.09 0 219.03 0.366667 220.91 1.1C222.797 1.83333 224.473 2.92333 225.94 4.37C227.407 5.82333 228.573 7.63333 229.44 9.8C230.307 11.9667 230.74 14.5 230.74 17.4L230.74 17.4C230.74 20.2333 230.307 22.7333 229.44 24.9C228.573 27.0667 227.407 28.8833 225.94 30.35C224.473 31.8167 222.807 32.9233 220.94 33.67C219.073 34.4233 217.123 34.8 215.09 34.8ZM215.09 33.3L215.09 33.3C216.99 33.3 218.523 32.8067 219.69 31.82C220.857 30.84 221.707 29.1833 222.24 26.85C222.773 24.5167 223.04 21.3667 223.04 17.4L223.04 17.4C223.04 13.4333 222.773 10.29 222.24 7.97C221.707 5.65667 220.857 4.00667 219.69 3.02C218.523 2.04 216.99 1.55 215.09 1.55L215.09 1.55C213.223 1.55 211.697 2.04 210.51 3.02C209.33 4.00667 208.473 5.65667 207.94 7.97C207.407 10.29 207.14 13.4333 207.14 17.4L207.14 17.4C207.14 21.3667 207.407 24.5167 207.94 26.85C208.473 29.1833 209.33 30.84 210.51 31.82C211.697 32.8067 213.223 33.3 215.09 33.3Z",
    sodipodiNodetypes: "cccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "group6",
    transform: "matrix(0.995024902878658 0 0 0.995024902878658 158.064919285553 5.94624793848197e-10)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group7",
    transform: "matrix(0.999999953693143 0 0 0.999999953693143 0 5.14052842959245e-07)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group8",
    transform: "matrix(0.842786230353309 0 0 0.842786230353309 -2.94189104693967 -0.842786230353326)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape1",
    transform: "translate(12.983, 0.999999999999957)",
    fill: "#c56e33",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M0 9.59L17.018 97.813L11.146 38.764L40.167 36.872L40.113 26.989L51.566 0L40.639 17.977Z",
    sodipodiNodetypes: "cccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape2",
    transform: "translate(30.001, 1.00700000000001)",
    fill: "#c56e33",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M29.388 53.541L34.548 0L25.808 39.716L6.196 40.761L7.766 61.223L0 97.806L12.057 57.907Z",
    sodipodiNodetypes: "cccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape3",
    transform: "translate(30.001, 56.729)",
    fill: "#c56e33",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M32.799 10.453L33.348 0L17.369 3.755L17.337 15.552L0 42.084L21.68 14.468Z",
    sodipodiNodetypes: "ccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape4",
    transform: "translate(65.711, 45.131)",
    fill: "#c56e33",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M0 17.263L14.841 12.532L16.35 0L0.451 2.095Z",
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape5",
    transform: "translate(64.549, 0.999999999999957)",
    fill: "#c56e33",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M7.521 43.502L18.509 42.085L20.09 31.807L12.011 31.434L0 0L8.43 30.967Z",
    sodipodiNodetypes: "ccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape6",
    transform: "translate(64.549, 0.999999999999957)",
    fill: "#c56e33",
    fillRule: "evenodd",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    d: "M22.864 30.294L24.12 20.788L14.576 18.094L0 0L14.483 22.437L14.061 29.437Z",
    sodipodiNodetypes: "ccccccc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "group9",
    transform: "matrix(0.995024902878658 0 0 0.995024902878658 3.5527136788005e-15 5.94624793848197e-10)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shape7",
    transform: "translate(238.642360469549, 76.0562092748556)",
    fill: "#c56e33",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    width: 82.3221195304509,
    height: 5.37924325818883
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape8",
    transform: "translate(76.53312, 76.0562092748556)",
    fill: "#c56e33",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    width: 82.3221195304509,
    height: 5.37924325818883
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "shape9",
    display: "none",
    fill: "none",
    strokeOpacity: 0,
    stroke: "#000000",
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    width: 395.52,
    height: 174.753890389522
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemdemo);
export default __webpack_public_path__ + "static/media/demdemo.81d836632a0e1456910c659801e11761.svg";
export { ForwardRef as ReactComponent };